export const SOCIAL_MEDIA = {
  facebook: 'Facebook',
  instagram: 'Instagram',
  twitter: 'Twitter',
  linkedin: 'LinkedIn',
};
export const POSTS_PER_REQUEST = 6;
export const COMMENT_PER_REQUEST = 10;
